import React from "react";
import ProgressBar from "./ProgressBar";
import { PROGRESS_MODE } from "../progressMode";
import "../styles/loading.css";

export default function LoadingOverlay({
  message,
  mode = PROGRESS_MODE.INDETERMINATE,
  percent = null,
  progressLabel = "",
}) {
  return (
    <div className="gl-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="gl-overlay-card">
        <div className="gl-spinner" />
        <ProgressBar mode={mode} percent={percent} label={progressLabel} size="md" />
        <div className="gl-message">{message || "Processing…"}</div>
      </div>
    </div>
  );
}
